<div class="toast">
    <div *ngIf="data?.showIcon" class="icon">
        <img src="assets/img/verify-tick.png" alt="error">
    </div>
    <span class="message">{{data?.msg || 'Something went wrong!'}}</span>
</div>